export enum Feature {
  TestMarketingSsrSetup = "test-marketing-ssr-setup",
  SwapBurgerWithGetAppButton = "swap-burger-with-get-app-button",
  BlackoutReviewSlider = "blackout-the-review-slider-for-city-and-poi-pages",
  AddInstagramReelsToReviewsSlider = "instagram-reels-reviews-section",
}
